import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { academyPublicAPI } from '../../lib/academyApi';
import { CheckCircle, Loader2, XCircle, Clock } from 'lucide-react';

const PaymentConfirmationPage = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [status, setStatus] = useState('checking');
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!sessionId) { setStatus('error'); return; }

    const poll = async () => {
      try {
        const res = await academyPublicAPI.checkoutStatus(sessionId);
        if (res.data.payment_status === 'paid') {
          setStatus('success');
        } else if (res.data.status === 'expired') {
          setStatus('expired');
        } else if (attempts < 5) {
          setTimeout(() => setAttempts(a => a + 1), 2000);
        } else {
          setStatus('pending');
        }
      } catch {
        if (attempts < 3) setTimeout(() => setAttempts(a => a + 1), 2000);
        else setStatus('error');
      }
    };
    poll();
  }, [sessionId, attempts]);

  const content = {
    checking: { icon: Loader2, title: 'Verification du paiement...', desc: 'Veuillez patienter pendant que nous confirmons votre paiement.', color: '#F9B438', spin: true },
    success: { icon: CheckCircle, title: 'Paiement confirme!', desc: 'Votre inscription a ete enregistree avec succes. Vous recevrez un courriel de confirmation sous peu.', color: '#22c55e' },
    pending: { icon: Clock, title: 'Paiement en cours de traitement', desc: 'Votre paiement est en cours de traitement. Vous recevrez une confirmation par courriel.', color: '#F9B438' },
    expired: { icon: XCircle, title: 'Session expiree', desc: 'La session de paiement a expire. Veuillez reessayer.', color: '#ef4444' },
    error: { icon: XCircle, title: 'Erreur', desc: 'Une erreur est survenue lors de la verification du paiement.', color: '#ef4444' },
  };

  const c = content[status];
  const Icon = c.icon;

  return (
    <div className="min-h-screen bg-neutral-50 flex items-center justify-center p-4" data-testid="payment-confirmation-page">
      <Card className="max-w-md w-full">
        <CardContent className="p-8 text-center">
          <div className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6" style={{ background: `${c.color}20` }}>
            <Icon className={`w-10 h-10 ${c.spin ? 'animate-spin' : ''}`} style={{ color: c.color }} />
          </div>
          <h1 className="font-heading text-2xl font-bold text-[#1D1D1B] mb-3">{c.title}</h1>
          <p className="text-neutral-600 mb-8">{c.desc}</p>
          <div className="flex flex-col gap-3">
            <Link to="/academie"><Button className="w-full">Retour au catalogue</Button></Link>
            <Link to="/"><Button variant="outline" className="w-full">Retour a l'accueil</Button></Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentConfirmationPage;
